<span class="ui-action-toast__check" aria-hidden="true">
  <img src="/assets/toast/check.svg" alt="" />
</span>
<span class="ui-action-toast__message">{{ data.message }}</span>
@if (data.actionLabel) {
  <span class="ui-action-toast__divider" aria-hidden="true"></span>
  <button type="button" class="ui-action-toast__action" (click)="action()">
    {{ data.actionLabel }}
  </button>
}
<button type="button" class="ui-action-toast__close" aria-label="Dismiss" (click)="dismiss()">
  <img src="/assets/toast/close.svg" alt="" />
</button>
